
import CoolLightBox from 'vue-cool-lightbox';
import ReviewsCommentAttachmentImageItem from '~/components/catalog/reviews/Comment/Attachment/Image/Item';

export default {
  name: 'ReviewsCommentAttachmentImage',
  components: {ReviewsCommentAttachmentImageItem, CoolLightBox},
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      imageOpenIndex: null,
    }
  },
  computed: {
    galleryItems() {
      return this.images.map(image => {
        return {
          src: image.url,
        }
      })
    },
  },
  methods: {
    openImage(index) {
      console.log('openImage', index)
      this.imageOpenIndex = index;
    },
  },
}
